import React from "react";
import { matchPath, useLocation } from "react-router-dom";
import StoreMallDirectoryRoundedIcon from "@material-ui/icons/StoreMallDirectoryRounded";
import ParentMenu from "ui/layout/Menu/components/ParentMenu/ParentMenu";
import { CustomMenuItemLink } from "../CustomMenuItemLink/CustomMenuItemLink";
import {
  MENU_ITEM_IDS,
  SUB_MENU_CONFIG,
  TOOGLE_PARENT_MENU_KEYS,
} from "../../constants/Menu.constants";
import { app_route_ids, app_route_keys } from "constants/urlPaths";
import { RESOURCE_KEYS } from "utils/OrgPermissions";
import { MenuBadge } from "../MenuBadge/MenuBadge";
import { SALES_PAGES_ROUTE_KEYS } from "features/SalesPages/constants/SalesPages.constants";
import {
  GJS_HOMEPAGE_BUILDER_ROUTE_IDS,
  GJS_HOMEPAGE_BUILDER_ROUTE_KEYS,
} from "features/HomepageBuilder/constants/HomepageBuilder.constants";

export const Storefront = ({
  has_permission,
  returnEdgeElementsFromParentMenu,
  VISIBLE_MENU_ITEMS_CONFIG,
  handleToggle,
  state,
  setState,
  dense,
  isToolTipTourActive,
  config,
  open,
  activeTooltipIndex,
  moveToAnotherMenuItem,
  commonMenuItemLinkProps,
  styles,
}) => {
  const location = useLocation();

  const pathNames = [
    `/${app_route_ids[app_route_keys.manage_webpage]}`,
    `/${app_route_ids[app_route_keys.manage_webpage_templates]}`,
    `/${app_route_ids[app_route_keys.sales_pages_home]}`,
    `/${app_route_ids[app_route_keys.thank_you_pages_home]}`,
    `/${app_route_ids[app_route_keys.checkout_page_listing]}`,
    `${app_route_ids[app_route_keys.seo_categories]}`,
  ];
  const matchResults = pathNames.some((url) =>
    matchPath(location.pathname, {
      path: url,
    })
  );

  React.useEffect(() => {
    setState((prev) => ({
      ...prev,
      [TOOGLE_PARENT_MENU_KEYS.STOREFRONT]: matchResults,
    }));
  }, [matchResults]);

  if (!has_permission(RESOURCE_KEYS.SECTIONS.STOREFRONT)) {
    return <></>;
  }

  const { firstVisibleItem: firstStorefrontItem } =
    returnEdgeElementsFromParentMenu({
      parentMenuItemsArr: SUB_MENU_CONFIG[TOOGLE_PARENT_MENU_KEYS.STOREFRONT],
      visibleItems: VISIBLE_MENU_ITEMS_CONFIG,
    });

  const toggleStorefrontMenu = () =>
    handleToggle(TOOGLE_PARENT_MENU_KEYS.STOREFRONT);

  return (
    <div id="Storefront">
      <ParentMenu
        handleToggle={toggleStorefrontMenu}
        isOpen={state.menuStorefront}
        sidebarIsOpen={open}
        name="Storefront"
        icon={<StoreMallDirectoryRoundedIcon />}
        dense={dense}
        {...(isToolTipTourActive &&
          config[activeTooltipIndex] === firstStorefrontItem && {
            menuItemClassName: styles.tooltipContainer,
          })}
      >
        {VISIBLE_MENU_ITEMS_CONFIG[MENU_ITEM_IDS.YOUR_WEBSITE] && (
          <CustomMenuItemLink
            to={
              GJS_HOMEPAGE_BUILDER_ROUTE_IDS[
                GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.storefront_homepage
              ]
            }
            id={MENU_ITEM_IDS.YOUR_WEBSITE}
            primaryText="Home Page"
            handleToggleParent={moveToAnotherMenuItem}
            {...commonMenuItemLinkProps}
          />
        )}
        {VISIBLE_MENU_ITEMS_CONFIG[MENU_ITEM_IDS.MOBILE_APP] && (
          <div className="tw-flex tw-gap-2">
            <CustomMenuItemLink
              to={app_route_ids[SALES_PAGES_ROUTE_KEYS.mobile_app]}
              primaryText={
                <>
                  Mobile App <MenuBadge text="New" />
                </>
              }
              id={MENU_ITEM_IDS.MOBILE_APP}
              handleToggleParent={moveToAnotherMenuItem}
              {...commonMenuItemLinkProps}
            />
          </div>
        )}
        {VISIBLE_MENU_ITEMS_CONFIG[MENU_ITEM_IDS.LANDING_PAGES] && (
          <CustomMenuItemLink
            to={"/" + app_route_ids[app_route_keys.sales_pages_home]}
            id={MENU_ITEM_IDS.LANDING_PAGES}
            primaryText="Landing Pages"
            handleToggleParent={moveToAnotherMenuItem}
            {...commonMenuItemLinkProps}
          />
        )}
        {VISIBLE_MENU_ITEMS_CONFIG[MENU_ITEM_IDS.PAYMENT_PAGES] && (
          <CustomMenuItemLink
            to={"/" + app_route_ids[app_route_keys.checkout_page_listing]}
            id={MENU_ITEM_IDS.PAYMENT_PAGES}
            primaryText="Checkout Pages"
            handleToggleParent={moveToAnotherMenuItem}
            {...commonMenuItemLinkProps}
          />
        )}
        {VISIBLE_MENU_ITEMS_CONFIG[MENU_ITEM_IDS.THANK_YOU_PAGES] && (
          <CustomMenuItemLink
            to={"/" + app_route_ids[app_route_keys.thank_you_pages_home]}
            id={MENU_ITEM_IDS.THANK_YOU_PAGES}
            primaryText="Thankyou Pages"
            handleToggleParent={moveToAnotherMenuItem}
            {...commonMenuItemLinkProps}
          />
        )}
        {VISIBLE_MENU_ITEMS_CONFIG[MENU_ITEM_IDS.BLOG] && (
          <CustomMenuItemLink
            to={`/Blogs`}
            primaryText={`Blog`}
            id={MENU_ITEM_IDS.BLOG}
            handleToggleParent={moveToAnotherMenuItem}
            {...commonMenuItemLinkProps}
          />
        )}
        {VISIBLE_MENU_ITEMS_CONFIG[MENU_ITEM_IDS.SEO] && (
          <CustomMenuItemLink
            to={app_route_ids[app_route_keys.seo_categories]}
            id={MENU_ITEM_IDS.SEO}
            primaryText="SEO Settings"
            handleToggleParent={moveToAnotherMenuItem}
            {...commonMenuItemLinkProps}
          />
        )}
      </ParentMenu>
    </div>
  );
};
